// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"2b035a29","84":"340c77eb","247":"f833e738","627":"73ed6dd0","834":"5ccc839d","867":"d6250b18","923":"d04b2f58"}[chunkId] + ".chunk.js";
};